import { QUESTIONNAIRE_DETAILS } from "../_constants/questionnaireDetails.constant"

const initialState = {
  loadingQuestionnaireDetails: false,
  questionnaireDetails: undefined,
  currantSectionIndex:0,
}

export function questionnaireDetailsReducer(state = initialState, action) {
  switch (action.type) {

    case QUESTIONNAIRE_DETAILS.SET_LOADING_DETAILS:
      return { ...state, loadingQuestionnaireDetails: action.data }

    case QUESTIONNAIRE_DETAILS.SET_QUESTIONNAIRE_DETAILS_DATA:
      return { ...state, questionnaireDetails: action.data, loadingQuestionnaireDetails: false }

    case QUESTIONNAIRE_DETAILS.CHANGE_SECTION_INDEX:
      return {...state , currantSectionIndex:action.data}

    case QUESTIONNAIRE_DETAILS.CLEAR:
      return {...initialState}
    default:
      return state
  }
}